import React from 'react'
import type { FieldSummary } from '@core/Areas/RaceCardFixedOnly/Types/FieldSummary'
import {
  PropositionJockeyNameStyled,
  PropositionStrongFieldsStyled,
  PropositionSummaryStyled,
  PropositionTrainerNameStyled,
  PropositionTrotFieldStyled,
  SelectionFormTableStyled,
} from '@core/Areas/RaceCardFixedOnly/RaceCardFixedOnly.styles'

type Props = {
  summary: FieldSummary
}
export const TrotFieldSummary: React.FC<Props> = ({ summary }) => {
  if (!summary) return null

  return (
    <PropositionSummaryStyled>
      <SelectionFormTableStyled>
        <PropositionTrotFieldStyled>
          <div>
            <PropositionStrongFieldsStyled>F:</PropositionStrongFieldsStyled>
            <span>{summary.lastFour}</span>
          </div>
          <div>
            <span>{summary.handicapDistance}</span>
          </div>
        </PropositionTrotFieldStyled>
        <PropositionJockeyNameStyled>
          <PropositionStrongFieldsStyled>D:</PropositionStrongFieldsStyled>
          <span className={summary.isRiderChanged ? 'rider-change fg-gray-lightest' : ''}>
            {summary.jockeyName?.toUpperCase()}
          </span>
        </PropositionJockeyNameStyled>
        <PropositionTrainerNameStyled>
          <PropositionStrongFieldsStyled>T:</PropositionStrongFieldsStyled>
          <span>{summary.trainerName}</span>
        </PropositionTrainerNameStyled>
      </SelectionFormTableStyled>
    </PropositionSummaryStyled>
  )
}
